<template>
  <div class="page-search" :class="{'mobile': _isMobile}">
    <div class="search-wrap" :class="{'pc': !_isMobile}">
      <cmpBanner bannerType="9"></cmpBanner>
  
      <div class="g-wrap">
        <div class="g-content">
          <div class="search-box">
            <el-input ref="myInput" clearable v-model="listQuery.keywords" placeholder="输入关键词搜索" @keyup.enter.native="handleSearch" @input="handleChange" style="width:100%;">
              <!-- <i slot="prefix" class="el-input__icon el-icon-search"></i> -->
              <!-- <el-button slot="append" icon="el-icon-search" @click="handleSearch"></el-button> -->
            </el-input>
    
            <!-- <div class="btn-search">搜索</div> -->
            <el-button class="btn-search" type="primary" @click="handleSearch">搜索</el-button>
            <!-- <div class="com-head-search-btns">
              <el-button type="primary" @click="handleSearch">搜索</el-button>
            </div> -->
          </div>
          
          <p class="tips" v-show="dataList.length">约有 <span>{{total}}</span> 个结果</p>
          <div class="list-box g-pad-bottom">
            <div class="item" :class="{'zixun': item.type==='webInformation'}" v-for="(item, index) in dataList" :key="index" @click="goDetail(item)">
              <!-- 有图片 -->
              <div class="item-box-1" v-if="item.img">
                <h2 class="ell">{{item.typeName}} <i class="el-icon-arrow-right"></i> <span v-html="item.title"></span></h2>
                <div class="g-card-2">
                  <div class="pic-box">
                    <img v-lazy="item.img" alt="">
                  </div>
                  <div class="g-border-box white" style="flex:1;">
                    <div class="info">
                      <!-- <h2 class="ell">资讯 辽宁省博物馆的馆藏精品</h2> -->
                      <div class="two-ell" v-html="item.text"></div>
                      <!-- <div class="line"></div> -->
                      <!-- <p class="addr">
                        所属单位：{{item.publisher}}
                        <span class="ml-30" v-if="activeVal==='xshy'">时间：{{item.createTime}}</span>
                      </p> -->
                    </div>
                  </div>
                </div>
              </div>
    
              <!-- 没图片的模块 -->
              <div class="item-box-2" v-else>
                <div class="info">
                  <h2 class="title ell" v-html="item.name"></h2>
                  <!-- <span>{{item.typeName}}</span> -->
                </div>
                <!-- <div class="desc two-ell" v-html="item.text"></div> -->
              </div>
            </div>
          </div>
    
          <!-- 无数据 -->
          <div class="g-no-data" v-if="showSearch && dataList.length === 0 && !listLoading">
            <div class="no-data-bg"></div>
            <p class="txt text-center">暂无数据</p>
          </div>
          <cmpMyPagination :currentPage="listQuery.page" :pageSize="listQuery.size" :total="total" @eventPage="eventPage"></cmpMyPagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@assets/css-mobile/search/index.scss'
// import cmpTab from '@cmp/tab'
// import myCmpLike from '@cmp/my-like'
// import cmpSearchDict from '@cmp/search-dict'
export default {
  // components: { cmpTab, myCmpLike, cmpSearchDict },
  data() {
    return {
      linkObj: {
        // 导览
        '1': '/museum',
        '2': '/exhibition',
      },
      activeVal: '1',
      tabList: [
        {
          name: '可移动革命文物',
          val: '1'
        },
        {
          name: '不可移动革命文物',
          val: '2'
        }
      ],
      dataList: [],
      listQuery: {
        keywords: '',
        page: 1,
        size: 10,
      },
      total: '0',
      listLoading: false,
      showSearch: false  // 显示暂无数据
    }
  },
  methods: {
    getDataList() {
      this.listLoading = true
      this.$http
        .get('/webapi/search', {
          ...this.listQuery,
          name: this.listQuery.keywords
        })
        .then(res => {
          this.listLoading = false
          this.showSearch = true
          if (res.success) {
            this.dataList = res.data.records
            this.total = res.data.total
            console.log(111, this.dataList)
          } else {
            this.$message.error(res.message)
          }
        })
    },
    handleChange() {
      this.showSearch = false
    },
    handleSearch() {
      if(!this.listQuery.keywords) {
        this.$message.warning('关键词不能为空')
        return
      }
      this.listQuery.page = 1
      this.getDataList()
    },
    // 获取头部参数
    getHeadParams(params) {
      console.log(params)
      this.listQuery.page = 1
      this.headParams.name = params.key
      this.headParams.type = params.musenumType
      this.headParams.area = params.city
      this.headParams.year = params.year
      this.getDataList()
    },
    eventTabClick(val) {
      console.log(val)
      this.activeVal = val
      if(val === '1') {
        this.listQuery.size = 9
      } else {
        this.listQuery.size = 8
      }
      this.listQuery.page = 1
      this.getDataList()
    },
    goDetail(item) {
      let routeUrl = ''
      // index说明 1-9 首页、信息、参观、展览、馆藏精品、社教、服务、视频、文化
      console.log(item.index)
      switch(item.index) {
        case 1:
          routeUrl = this.$router.resolve({
            path: '/home',
            query: {}
          })
          break
        // 信息
        case 2:
          // if(item.subIndex == '3') {
          if(item.detail) {
            // 详情
            routeUrl = this.$router.resolve({
              path: '/information/detail',
              query: {
                pageType: item.subIndex,
                id: item.id
              }
            })
          } else {
            routeUrl = this.$router.resolve({
              path: '/information',
              query: {
                pageType: item.subIndex,
                subType: item.id
              }
            })
          }
          break
        // 参观
        case 3:
          routeUrl = this.$router.resolve({
            path: '/visit',
            query: {
              pageType: item.subIndex
            }
          })
          // window.open(item.video)
          break
        // 展览
        case 4:
          routeUrl = this.$router.resolve({
            path: '/exhibition/detail',
            query: {
              pageType: item.subIndex,
              id: item.id
            }
          })
          break
        // 馆藏精品
        case 5:
          // if(item.subIndex == '1' || item.subIndex == '3') {
          if(item.detail) {
            // 详情
            routeUrl = this.$router.resolve({
              path: '/collect/detail',
              query: {
                pageType: item.subIndex,
                id: item.id
              }
            })
          } else {
            routeUrl = this.$router.resolve({
              path: '/collect',
              query: {
                pageType: item.subIndex
              }
            })
          }
          break
        // 社教
        case 6:
          routeUrl = this.$router.resolve({
            path: 'activity/detail',
            query: {
              pageType: item.subIndex,
              id: item.id
            }
          })
          break
        // 服务
        case 7:
          routeUrl = this.$router.resolve({
            path: '/service',
            query: {
              pageType: item.subIndex
            }
          })
          break
        // 视频
        case 8:
          window.open(item.url)
          break
        // 文化
        case 9:
          // if(item.subIndex == '3' || item.subIndex == '5' || item.subIndex == '6') {
          if(item.detail) {
            // 详情
            routeUrl = this.$router.resolve({
              path: '/culture/detail',
              query: {
                pageType: item.subIndex,
                id: item.id
              }
            })
          } else {
            routeUrl = this.$router.resolve({
              path: '/culture',
              query: {
                pageType: item.subIndex
              }
            })
          }
          break
      }
      if(item.index == 8) {
        return
      }
      window.open(routeUrl .href, '_blank')
    },
    eventPage(obj) {
      this.listQuery.page = obj.page
      this.listQuery.size = obj.size
      this.getDataList()
    },
  },
  created() {
    // this.getDataList()
  },
  mounted(){
    this.$refs.myInput.focus()
  }
}
</script>

<style lang="scss" scoped>
.search-wrap {
  .search-box {
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
    // /deep/ .el-input {
    //   flex: 1;
    //   font-size: 16px;
    //   .el-input__inner {
    //     height: 64px;
    //     border-color: rgba($color: #312F2E, $alpha: 0.2);
    //     // border-radius: 0;
    //     &:hover,
    //     &:focus {
    //       border-color: $primary;
    //       background: inherit;
    //     }
    //   }
    //   .el-input-group__append {
    //     background-color: $primary;
    //     // border: 1px solid $primary;
    //     border: none;
    //   }
    //   .el-icon-search:before {
    //     color: #fff;
    //   }

    //   // .el-icon-circle-close:before {
    //   //   font-size: 24px;
    //   //   position: absolute !important;
    //   //   top: 15px !important;
    //   //   right: 5px !important;
    //   // }
    // }

    .btn-search {
      width: 236px;
    }
  }

  .tips {
    padding: 40px 0;
    color: rgba($color: #000000, $alpha: 0.7);
    font-size: 18px;
    border-bottom: solid 1px rgba($color: #121100, $alpha: 0.2);
    // span {
    //   color: $primary;
    // }
  }

  .list-box {
    .item {
      padding: 30px 0;
      margin: 0;
      border-bottom: 1px dashed #8894A8;;
      cursor: pointer;
      &:last-child {
        border-bottom: none;
      }
      .g-card-2 {
        margin: 0;
      }
      h2 {
        font-size: 18px;
        color: #000000;
        margin-bottom: 20px;
      }
      // &:hover {
      //   h2 {
      //     color: $primary;
      //   }
      // }
      .pic-box {
        img {
          width: 372px;
          height: 210px;
          object-fit: contain;
        }
      }
      .info {
        // font-size: 18px;
        color: rgba($color: #000000, $alpha: 0.9);
        height: 100%;
        // background: #fff;
        box-sizing: border-box;
      }
      // &.zixun {
      //   .pic-box {
      //     img {
      //       width: 256px;
      //       height: 256px;
      //     }
      //   }
      // }
    }

    .item-box-2 {
      position: relative;
      padding: 10px 0;
      // padding-left: 40px;
      .info {
        display: flex;
        justify-content: space-between;
        align-items: center;
        // todo open
        // &:before {
        //   content: '';
        //   display: block;
        //   width: 16px;
        //   height: 16px;
        //   border: solid 1px $primary;
        //   border-radius: 100%;
        //   position: absolute;
        // }
        &:before {
          left: 0;
          top: 13px;
        }
        h2 {
          width: 1200px;
          margin-bottom: 0;
        }
        span {
          font-size: 18px;
          color: rgba($color: #000000, $alpha: 0.7);
        }
      }
      .desc {
        margin-top: 10px;
        font-size: 16px;
        line-height: 24px;
      }
    }
  }

  // 高亮文字
  /deep/ .searchhit {
    color: $primary;
  }
}
</style>


